export const selectWidgetsData = state => state.widgets.data

export const selectWidgetsLoadingStatus = state => state.widgets.loading
